
import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { replayMatches } from '../../mocks/sportsData';
import { useMessage } from '../../App';
import { getLoginMreg } from '@/services/login';
import { message } from 'antd';
import { getcommunityCommentReply } from '../../services/community';
import { getLiveList, getliveFocusDel, getliveFocusAdd, } from '../../services/live';
import { maskUsername } from '@/utils/common';
import { useSelector } from 'react-redux';
import type { RootState } from '../../store';
// 修改密码接口参数兼容

export default function Profile() {
  // 退出登录逻辑
  const handleLogout = () => {
    localStorage.removeItem('userInfo');
    localStorage.removeItem('authToken');
    message.success('已退出登录');
    // 可选：清除其他登录相关缓存
    window.location.href = '/'; // 跳转到登录页
  };
  const [activeTab, setActiveTab] = useState('overview');
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  // 使用消息系统
  const { showSuccess, showError, showWarning, showInfo } = useMessage();

  const [isEditing, setIsEditing] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [favoriteReplays, setFavoriteReplays] = useState<number[]>([]);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState<{ [key: string]: string }>({});
  const [isChangingPassword, setIsChangingPassword] = useState(false);

  const [subscriptionSettings, setSubscriptionSettings] = useState({
    matchReminder: true,
    newsPush: true,
    communityInteraction: false,
  });

  //收藏数据
  const [replayMatches, setReplayMatches] = useState<any[]>([]);

  //观看历史数据
  const [watchHistory, setWatchHistory] = useState<any[]>([]);

  // 从本地存储或登录注册后保存的数据获取用户信息
  const [userInfo, setUserInfo] = useState(() => {
    // 登录注册后用户信息保存在 localStorage.userInfo，结构如 { token, id, username }
    const local = localStorage.getItem('userInfo');
    if (local) {
      try {
        const parsed = JSON.parse(local);
        // 兼容旧结构和新结构
        return {
          nickname: maskUsername(parsed.username || parsed.nickname || '未登录用户'),
          email: parsed.email || '',
          phone: parsed.phone || '',
          location: parsed.location || '',
          joinDate: parsed.joinDate || '',
          level: parsed.level || ''
        };
      } catch {
        return {
          nickname: '未登录用户',
          email: '',
          phone: '',
          location: '',
          joinDate: '',
          level: ''
        };
      }
    }
    return {
      nickname: '未登录用户',
      email: '',
      phone: '',
      location: '',
      joinDate: '',
      level: ''
    };
  });

  // 新增提醒方式设置状态
  const [notificationSettings, setNotificationSettings] = useState({
    pushNotification: true,
    emailReminder: true,
    smsNotification: false,
    inAppMessage: true
  });


  const { configInfo } = useSelector((state: RootState) => state.settings);

  const handleOpenUrl = (e: React.MouseEvent, url?: string) => {
    e.preventDefault();
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  useEffect(() => {
    const { matchReminder, newsPush, communityInteraction } = subscriptionSettings;
    if (matchReminder || newsPush || communityInteraction) {
      const intervalId = setInterval(() => {
        getcommunityCommentReply().then(res => {
          if (res && res.data && res.data.count > 0) {
            message.info(`You have ${res.data.count} new replies.`);
          }
        });
      }, 60000); // Poll every 60 seconds

      return () => clearInterval(intervalId);
    }
  }, [subscriptionSettings]);

  // 处理订阅设置改变
  const handleSubscriptionChange = (key: keyof typeof subscriptionSettings) => {
    setSubscriptionSettings(prev => ({ ...prev, [key]: !prev[key] }));
  };
  // 新增订阅数据
  const [subscriptions, setSubscriptions] = useState([
    { id: 1, name: '英超联赛', type: '联赛', status: 'active', price: '免费', nextMatch: '2024-01-15 20:30' },
    { id: 2, name: 'NBA常规赛', type: '联赛', status: 'active', price: '免费', nextMatch: '2024-01-16 09:00' },
    { id: 3, name: '欧冠决赛', type: '特殊赛事', status: 'active', price: 'VIP专享', nextMatch: '2024-06-01 21:00' },
    { id: 4, name: 'ATP网球巡回赛', type: '联赛', status: 'paused', price: '免费', nextMatch: '2024-01-20 15:00' },
    { id: 5, name: 'F1大奖赛', type: '赛车', status: 'active', price: 'VIP专享', nextMatch: '2024-02-05 14:00' }
  ]);

  const fetchReplayMatches = () => {
    getLiveList({
      state: '3',
      category_id: '',
      type: 1
    }).then(res => {
      if (res && res.status === 1 && Array.isArray(res.data?.lists)) {
        setReplayMatches(res.data.lists);
      } else {
        setReplayMatches([]);
      }
    });
  };

  const fetchwatchHistory = () => {
    getLiveList({
      state: '9',
      category_id: '',
      type: 2
    }).then(res => {
      if (res && res.status === 1 && Array.isArray(res.data?.lists)) {
        setWatchHistory(res.data.lists);
      } else {
        setWatchHistory([]);
      }
    });
  };
  useEffect(() => {
    fetchReplayMatches();
    fetchwatchHistory();
  }, []); //
  // 加载收藏的回放数据
  useEffect(() => {
    const savedFavorites = localStorage.getItem('favoriteReplays');
    if (savedFavorites) {
      try {
        const favoritesArray = JSON.parse(savedFavorites);
        setFavoriteReplays(favoritesArray);
      } catch (error) {
        console.error('Failed to parse favorite replays:', error);
      }
    }
  }, [activeTab]); // 当切换到收藏页面时重新加载

  // 移除收藏回放
  const handleRemoveFavorite = (replayId: number) => {
    const updatedFavorites = favoriteReplays.filter(id => id !== replayId);
    setFavoriteReplays(updatedFavorites);
    localStorage.setItem('favoriteReplays', JSON.stringify(updatedFavorites));

    getliveFocusDel({ id: match.id }).then(res => {
      if (!res || res.status !== 1) {
        // If the API call fails, revert the state to its original value
        message.success(res?.info || '操作失败');
        // Optional: show an error message to the user
        console.error('Failed to update focus status:', res?.msg);
      } else {
        fetchReplayMatches();

        const successDiv = document.createElement('div');
        successDiv.className = 'fixed top-4 right-4 bg-green-500 text-white px-4 py-3 rounded-lg shadow-lg z-50 flex items-center';
        successDiv.innerHTML = '<i class="ri-check-line mr-2"></i>已从收藏中移除';
        document.body.appendChild(successDiv);

        setTimeout(() => {
          if (document.body.contains(successDiv)) {
            document.body.removeChild(successDiv);
          }
        }, 3000);

        message.success(res?.info || '操作成功');
      }
    }).catch(error => {
      console.error('Error updating focus status:', error);
    });

  };

  // 播放收藏的回放
  const handlePlayFavoriteReplay = (replay: any) => {
    console.log('Playing replay:', replay);
    const playDiv = document.createElement('div');
    playDiv.className = 'fixed top-4 right-4 bg-blue-500 text-white px-4 py-3 rounded-lg shadow-lg z-50 flex items-center';
    playDiv.innerHTML = '<i class="ri-play-circle-line mr-2"></i>正在播放回放...';
    document.body.appendChild(playDiv);

    setTimeout(() => {
      if (document.body.contains(playDiv)) {
        document.body.removeChild(playDiv);
      }
    }, 3000);
  };

  const formatViews = (count: number) => {
    if (count >= 1000000) return `${(count / 1000000).toFixed(1)}M`;
    if (count >= 1000) return `${(count / 1000).toFixed(1)}K`;
    return count.toString();
  };

  // Handle change password modal
  const handleChangePasswordClick = () => {
    setShowChangePasswordModal(true);
    setPasswordForm({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
    setPasswordErrors({});
  };

  const handleClosePasswordModal = () => {
    setShowChangePasswordModal(false);
    setPasswordForm({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
    setPasswordErrors({});
    setShowCurrentPassword(false);
    setShowNewPassword(false);
    setShowConfirmPassword(false);
  };

  const handlePasswordFormChange = (field: string, value: string) => {
    setPasswordForm(prev => ({
      ...prev,
      [field]: value
    }));

    if (passwordErrors[field]) {
      setPasswordErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const validatePasswordForm = () => {
    const errors: { [key: string]: string } = {};

    if (!passwordForm.currentPassword) {
      errors.currentPassword = '请输入当前密码';
    }

    if (!passwordForm.newPassword) {
      errors.newPassword = '请输入新密码';
    } else if (passwordForm.newPassword.length < 6) {
      errors.newPassword = '新密码长度至少6位';
    } else if (passwordForm.newPassword === passwordForm.currentPassword) {
      errors.newPassword = '新密码不能与当前密码相同';
    }

    if (!passwordForm.confirmPassword) {
      errors.confirmPassword = '请确认新密码';
    } else if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      errors.confirmPassword = '两次输入的密码不一致';
    }

    setPasswordErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handlePasswordSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validatePasswordForm()) {
      return;
    }
    setIsChangingPassword(true);
    try {
      // 对接 getLoginMreg 修改密码接口
      const res = await getLoginMreg({
        old_password: passwordForm.currentPassword,
        new_password: passwordForm.newPassword,
        new_password_confirm: passwordForm.confirmPassword
      });
      if (res && res.status === 1) {
        const successDiv = document.createElement('div');
        successDiv.className = 'fixed top-4 right-4 bg-green-500 text-white px-4 py-3 rounded-lg shadow-lg z-50 flex items-center';
        successDiv.innerHTML = '<i class="ri-check-line mr-2"></i>密码修改成功！';
        document.body.appendChild(successDiv);
        setTimeout(() => {
          if (document.body.contains(successDiv)) {
            document.body.removeChild(successDiv);
          }
        }, 3000);
        handleClosePasswordModal();
      } else {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'fixed top-4 right-4 bg-red-500 text-white px-4 py-3 rounded-lg shadow-lg z-50 flex items-center';
        errorDiv.innerHTML = `<i class=\"ri-error-warning-line mr-2\"></i>${res?.msg || '密码修改失败，请重试'}`;
        document.body.appendChild(errorDiv);
        setTimeout(() => {
          if (document.body.contains(errorDiv)) {
            document.body.removeChild(errorDiv);
          }
        }, 3000);
      }
    } catch (error) {
      console.error('Password change failed:', error);
      const errorDiv = document.createElement('div');
      errorDiv.className = 'fixed top-4 right-4 bg-red-500 text-white px-4 py-3 rounded-lg shadow-lg z-50 flex items-center';
      errorDiv.innerHTML = '<i class="ri-error-warning-line mr-2"></i>密码修改失败，请重试';
      document.body.appendChild(errorDiv);
      setTimeout(() => {
        if (document.body.contains(errorDiv)) {
          document.body.removeChild(errorDiv);
        }
      }, 3000);
    } finally {
      setIsChangingPassword(false);
    }
  };

  // 新增处理提醒方式设置的函数
  const handleNotificationSettingChange = (setting: string, value: boolean) => {
    setNotificationSettings(prev => ({
      ...prev,
      [setting]: value
    }));

    // 显示设置保存成功的消息
    const settingNames: Record<string, string> = {
      pushNotification: '推送通知',
      emailReminder: '邮件提醒',
      smsNotification: '短信通知',
      inAppMessage: '站内消息'
    };

    showSuccess(
      `${settingNames[setting]}已${value ? '开启' : '关闭'}`,
      '提醒设置已保存'
    );
  };

  const tabs = [
    { id: 'overview', name: '概览', icon: 'ri-dashboard-line' },
    { id: 'favorites', name: '我的收藏', icon: 'ri-heart-line' },
    { id: 'history', name: '观看历史', icon: 'ri-history-line' },
    { id: 'subscription', name: '订阅管理', icon: 'ri-notification-line' }
  ];

  const favoriteMatches = [
    { id: 1, title: '皇马 vs 巴萨', date: '2024-03-15', status: '已结束' },
    { id: 2, title: '曼城 vs 利物浦', date: '2024-03-18', status: '即将开始' },
    { id: 3, title: '拜仁 vs 多特', date: '2024-03-20', status: '进行中' }
  ];

  // const watchHistory = [
  //   { id: 1, title: '欧冠决赛回放', duration: '90分钟', date: '2024-03-10' },
  //   { id: 2, title: '英超精彩集锦', duration: '45分钟', date: '2024-03-08' },
  //   { id: 3, title: 'NBA总决赛G6', duration: '120分钟', date: '2024-03-05' }
  // ];

  const renderOverview = () => (
    <div className="space-y-6">
      {/* 用户卡片 */}
      <div className="bg-gradient-to-r from-green-500 to-blue-600 rounded-xl p-6 text-white">
        <div className="flex items-center space-x-4">
          <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center">
            <i className="ri-user-line text-2xl"></i>
          </div>
          <div>
            <h2 className="text-xl font-bold">{userInfo.nickname}</h2>
            <p className="text-white/80">{userInfo.level}</p>
            <p className="text-white/60 text-sm">加入时间：{userInfo.joinDate}</p>
          </div>
        </div>
      </div>

      {/* 偏好设置 */}
      <div className="bg-white rounded-lg p-6">
        <h3 className="text-lg font-semibold mb-4">偏好设置</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">默认视频质量</label>
            <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent pr-8">
              <option>自动</option>
              <option>高清 1080p</option>
              <option>标清 720p</option>
              <option>流畅 480p</option>
            </select>
          </div>
        </div>
      </div>

      {/* 安全设置 */}
      <div className="bg-white rounded-lg p-6">
        <h3 className="text-lg font-semibold mb-4">安全设置</h3>
        <div className="space-y-3">
          <button
            onClick={handleChangePasswordClick}
            className="flex items-center justify-between w-full p-3 border rounded-lg hover:bg-gray-50 cursor-pointer"
          >
            <div className="flex items-center space-x-3">
              <i className="ri-lock-line text-gray-500"></i>
              <span>修改密码</span>
            </div>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
          </button>
        </div>
      </div>

      {/* 其他设置 */}
      <div className="bg-white rounded-lg p-6">
        <h3 className="text-lg font-semibold mb-4">其他</h3>
        <div className="space-y-3">
          <button  onClick={(e) => handleOpenUrl(e, configInfo?.live_url)} className="flex items-center justify-between w-full p-3 border rounded-lg hover:bg-gray-50 cursor-pointer">
            <div className="flex items-center space-x-3">
              <i className="ri-customer-service-line text-blue-500"></i>
              <span>联系客服</span>
            </div>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
          </button>

          <button
            className="flex items-center justify-between w-full p-3 border rounded-lg hover-red-50 text-red-600 cursor-pointer"
            onClick={handleLogout}
          >
            <div className="flex items-center space-x-3">
              <i className="ri-logout-circle-line"></i>
              <span>退出登录</span>
            </div>
            <i className="ri-arrow-right-s-line"></i>
          </button>
        </div>
      </div>
    </div>
  );

  const renderPersonalInfo = () => (
    <div className="bg-white rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold">个人信息</h3>
        <button
          onClick={() => setIsEditing(!isEditing)}
          className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          {isEditing ? '保存' : '编辑'}
        </button>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">昵称</label>
          {isEditing ? (
            <input
              type="text"
              value={userInfo.nickname}
              onChange={(e) => setUserInfo({ ...userInfo, nickname: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            />
          ) : (
            <p className="text-gray-900">{userInfo.nickname || '-'}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">邮箱</label>
          {isEditing ? (
            <input
              type="email"
              value={userInfo.email}
              onChange={(e) => setUserInfo({ ...userInfo, email: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            />
          ) : (
            <p className="text-gray-900">{userInfo.email || '-'}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">手机号</label>
          <p className="text-gray-900">{userInfo.phone || '-'}</p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">所在地区</label>
          {isEditing ? (
            <input
              type="text"
              value={userInfo.location}
              onChange={(e) => setUserInfo({ ...userInfo, location: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            />
          ) : (
            <p className="text-gray-900">{userInfo.location || '-'}</p>
          )}
        </div>
      </div>
    </div>
  );

  const renderFavorites = () => {
    const favoriteReplayData = replayMatches

    return (
      <div className="space-y-6">
        {/* 收藏列表 */}
        <div className="bg-white rounded-lg p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold flex items-center">
              <i className="ri-heart-fill text-red-500 mr-2"></i>
              我的收藏
            </h3>
            <span className="text-sm text-gray-600">共 {replayMatches.length} 个收藏</span>
          </div>

          <h4 className="font-semibold text-gray-900 mb-4">收藏的精彩回放</h4>

          {favoriteReplayData.length === 0 ? (
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-line text-gray-400 text-2xl"></i>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">还没有收藏任何回放</h3>
              <p className="text-gray-500 mb-4">去发现一些精彩的体育回放并收藏吧！</p>
              <Button
                onClick={() => {
                  window.location.href = '/#popular-replays';
                }}
                className="px-6 py-2 whitespace-nowrap"
              >
                <i className="ri-search-line mr-2"></i>
                发现精彩回放
              </Button>
            </div>
          ) : (
            <div className="space-y-4">
              {favoriteReplayData.map((replay) => (
                <div key={replay.id} className="flex items-center space-x-4 p-4 border rounded-lg hover:bg-gray-50 transition-colors">
                  {/* 缩略图 */}
                  <div className="relative flex-shrink-0">
                    <img
                      src={replay.thumbnail}
                      alt={replay.title}
                      className="w-32 h-20 object-cover rounded-lg"
                    />
                    <div className="absolute inset-0 bg-black/30 rounded-lg flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                      onClick={() => handlePlayFavoriteReplay(replay)}
                    >
                      <div className="w-8 h-8 bg-white/90 rounded-full flex items-center justify-center">
                        <i className="ri-play-fill text-blue-600 ml-0.5"></i>
                      </div>
                    </div>
                    <div className="absolute bottom-1 right-1 bg-black/70 text-white px-1.5 py-0.5 rounded text-xs">
                      {replay.duration}
                    </div>
                  </div>

                  {/* 回放信息 */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center space-x-2 mb-1">
                      <span className={`text-xs font-medium px-2 py-0.5 rounded ${replay.category.name === '足球' ? 'bg-green-100 text-green-700' :
                          replay.category.name === '篮球' ? 'bg-orange-100 text-orange-700' :
                            replay.category.name === '网球' ? 'bg-yellow-100 text-yellow-700' :
                              replay.category.name === '乒乓球' ? 'bg-red-100 text-red-700' :
                                'bg-gray-100 text-gray-700'
                        }`}>
                        {replay.category.name}
                      </span>
                      <span className="text-xs text-gray-500">{replay.league_name}</span>
                      <span className="text-xs text-gray-500">{replay.start_time}</span>
                    </div>
                    <h4 className="font-medium text-gray-900 mb-1 line-clamp-1">{replay.home}VS{replay.away}</h4>
                    <div className="flex items-center text-sm text-gray-600">
                      <i className="ri-eye-line mr-1"></i>
                      <span>{formatViews(replay.views || 0)} 观看</span>
                    </div>
                  </div>

                  {/* 操作按钮 */}
                  <div className="flex items-center space-x-2 flex-shrink-0">
                    <button
                      onClick={() => handlePlayFavoriteReplay(replay)}
                      className="px-3 py-1.5 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors text-sm cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-play-circle-line mr-1"></i>
                      播放
                    </button>
                    <button
                      onClick={() => handleRemoveFavorite(replay.id)}
                      className="px-3 py-1.5 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 transition-colors text-sm cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-heart-fill mr-1"></i>
                      取消收藏
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderHistory = () => {
    // const watchHistory = [
    //   { id: 1, title: '欧冠决赛回放', duration: '90分钟', date: '2024-03-10' },
    //   { id: 2, title: '英超精彩集锦', duration: '45分钟', date: '2024-03-08' },
    //   { id: 3, title: 'NBA总决赛G6', duration: '120分钟', date: '2024-03-05' }
    // ];

    return (
      <div className="bg-white rounded-lg p-6">
        <h3 className="text-lg font-semibold mb-4">观看历史</h3>
        <div className="space-y-3">
          {watchHistory.map((item) => (
            <div key={item.id} className="flex items-center justify-between p-3 border rounded-lg hover:bg-gray-50">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-gray-200 rounded-lg flex items-center justify-center">
                  <i className="ri-play-circle-line text-gray-500"></i>
                </div>
                <div>
                  <h4 className="font-medium">{item.home}VS{item.away}</h4>
                  <p className="text-sm text-gray-600">{item.league_name} • {item.start_time}</p>
                </div>
              </div>
              <button className="px-3 py-1 text-sm text-green-600 hover:bg-green-50 rounded cursor-pointer whitespace-nowrap">
                重播
              </button>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderSubscription = () => (
    <div className="space-y-6">
      {/* 提醒方式设置 - 新增 */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
          <i className="ri-notification-line text-blue-500 mr-2"></i>
          提醒方式设置
        </h3>
        <p className="text-gray-600 text-sm mb-6">
          设置您希望接收赛事提醒的方式，确保不错过任何精彩比赛
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* 推送通知 */}
          {/* <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                <i className="ri-notification-4-line text-blue-600"></i>
              </div>
              <div>
                <h4 className="font-medium text-gray-900">推送通知</h4>
                <p className="text-sm text-gray-600">浏览器推送消息提醒</p>
              </div>
            </div>
            <button
              onClick={() => handleNotificationSettingChange('pushNotification', !notificationSettings.pushNotification)}
              className={`relative w-12 h-6 rounded-full transition-colors cursor-pointer ${
                notificationSettings.pushNotification ? 'bg-green-500' : 'bg-gray-300'
              }`}
            >
              <div className={`absolute w-4 h-4 bg-white rounded-full top-1 transition-transform ${
                notificationSettings.pushNotification ? 'translate-x-7' : 'translate-x-1'
              }`} />
            </button>
          </div> */}

          {/* 邮件提醒 */}
          {/* <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                <i className="ri-mail-line text-green-600"></i>
              </div>
              <div>
                <h4 className="font-medium text-gray-900">邮件提醒</h4>
                <p className="text-sm text-gray-600">发送邮件到注册邮箱</p>
              </div>
            </div>
            <button
              onClick={() => handleNotificationSettingChange('emailReminder', !notificationSettings.emailReminder)}
              className={`relative w-12 h-6 rounded-full transition-colors cursor-pointer ${
                notificationSettings.emailReminder ? 'bg-green-500' : 'bg-gray-300'
              }`}
            >
              <div className={`absolute w-4 h-4 bg-white rounded-full top-1 transition-transform ${
                notificationSettings.emailReminder ? 'translate-x-7' : 'translate-x-1'
              }`} />
            </button>
          </div> */}

          {/* 短信通知 */}
          {/* <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
                <i className="ri-message-2-line text-orange-600"></i>
              </div>
              <div>
                <h4 className="font-medium text-gray-900">短信通知</h4>
                <p className="text-sm text-gray-600">发送短信到手机号码</p>
              </div>
            </div>
            <button
              onClick={() => handleNotificationSettingChange('smsNotification', !notificationSettings.smsNotification)}
              className={`relative w-12 h-6 rounded-full transition-colors cursor-pointer ${
                notificationSettings.smsNotification ? 'bg-green-500' : 'bg-gray-300'
              }`}
            >
              <div className={`absolute w-4 h-4 bg-white rounded-full top-1 transition-transform ${
                notificationSettings.smsNotification ? 'translate-x-7' : 'translate-x-1'
              }`} />
            </button>
          </div> */}

          {/* 站内消息 */}
          <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                <i className="ri-chat-3-line text-purple-600"></i>
              </div>
              <div>
                <h4 className="font-medium text-gray-900">站内消息</h4>
                <p className="text-sm text-gray-600">在网站内显示消息提醒</p>
              </div>
            </div>
            <button
              onClick={() => handleNotificationSettingChange('inAppMessage', !notificationSettings.inAppMessage)}
              className={`relative w-12 h-6 rounded-full transition-colors cursor-pointer ${notificationSettings.inAppMessage ? 'bg-green-500' : 'bg-gray-300'
                }`}
            >
              <div className={`absolute w-4 h-4 bg-white rounded-full top-1 transition-transform ${notificationSettings.inAppMessage ? 'translate-x-7' : 'translate-x-1'
                }`} />
            </button>
          </div>
        </div>

        {/* 提醒时间设置 */}
        <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-100">
          <h4 className="font-medium text-gray-900 mb-3 flex items-center">
            <i className="ri-time-line text-blue-500 mr-2"></i>
            提醒时间设置
          </h4>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <label className="flex items-center space-x-2 cursor-pointer">
              <input type="checkbox" defaultChecked className="rounded border-gray-300 text-blue-500 focus:ring-blue-500" />
              <span className="text-sm text-gray-700">开赛前1小时</span>
            </label>
            <label className="flex items-center space-x-2 cursor-pointer">
              <input type="checkbox" defaultChecked className="rounded border-gray-300 text-blue-500 focus:ring-blue-500" />
              <span className="text-sm text-gray-700">开赛前30分钟</span>
            </label>
            <label className="flex items-center space-x-2 cursor-pointer">
              <input type="checkbox" className="rounded border-gray-300 text-blue-500 focus:ring-blue-500" />
              <span className="text-sm text-gray-700">开赛前15分钟</span>
            </label>
            <label className="flex items-center space-x-2 cursor-pointer">
              <input type="checkbox" className="rounded border-gray-300 text-blue-500 focus:ring-blue-500" />
              <span className="text-sm text-gray-700">比赛开始时</span>
            </label>
          </div>
        </div>
      </div>

      {/* 订阅列表 */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        {/* 原始订阅设置项 */}
        <div className="flex items-center justify-between p-4 border rounded-lg">
          <div>
            <h4 className="font-medium">赛事提醒</h4>
            <p className="text-sm text-gray-600">关注的球队比赛开始前30分钟提醒</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={subscriptionSettings.matchReminder}
              onChange={() => handleSubscriptionChange('matchReminder')}
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-green-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
          </label>
        </div>

        <div className="flex items-center justify-between p-4 border rounded-lg">
          <div>
            <h4 className="font-medium">新闻推送</h4>
            <p className="text-sm text-gray-600">每日体育新闻精选推送</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={subscriptionSettings.newsPush}
              onChange={() => handleSubscriptionChange('newsPush')}
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-green-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
          </label>
        </div>

        <div className="flex items-center justify-between p-4 border rounded-lg">
          <div>
            <h4 className="font-medium">社区互动</h4>
            <p className="text-sm text-gray-600">有人回复我的评论时通知</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={subscriptionSettings.communityInteraction}
              onChange={() => handleSubscriptionChange('communityInteraction')}
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-green-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
          </label>
        </div>
      </div>
    </div>
  );

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return renderOverview();
      case 'favorites':
        return renderFavorites();
      case 'history':
        return renderHistory();
      case 'subscription':
        return renderSubscription();
      default:
        return renderOverview();
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <main className="container mx-auto px-4 py-8">
        <div className="flex flex-col lg:flex-row gap-6">
          {/* 左侧导航 */}
          <div className="w-full lg:w-64 flex-shrink-0">
            <div className="bg-white rounded-lg p-4">
              <div className="space-y-1">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors cursor-pointer ${activeTab === tab.id
                        ? 'bg-green-50 text-green-600 font-medium'
                        : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                      }`}
                  >
                    <i className={`${tab.icon} text-lg`}></i>
                    <span>{tab.name}</span>
                    {tab.id === 'favorites' && favoriteReplays.length > 0 && (
                      <span className="bg-red-500 text-white text-xs px-1.5 py-0.5 rounded-full ml-auto">
                        {replayMatches.length}
                      </span>
                    )}
                  </button>
                ))}
              </div>
            </div>

            {/* 移动端隐藏的用户信息卡片 */}
            <div className="hidden lg:block mt-6 bg-white rounded-lg p-4">
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-user-line text-2xl text-white"></i>
                </div>
                <h3 className="font-medium text-gray-900">{userInfo.nickname}</h3>
                <p className="text-sm text-gray-600">{userInfo.level}</p>
              </div>
            </div>
          </div>

          {/* 右侧内容区域 */}
          <div className="flex-1">
            {renderContent()}
          </div>
        </div>
      </main>

      {/* Change Password Modal */}
      {showChangePasswordModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-hidden animate-in slide-in-from-bottom-4 duration-300 flex flex-col">
            {/* Header */}
            <div className="relative bg-gradient-to-r from-blue-500 to-purple-600 text-white p-6 flex-shrink-0">
              <div className="absolute top-0 left-0 w-full h-full bg-[url('https://readdy.ai/api/search-image?query=modern%20security%20lock%20shield%20background%20with%20geometric%20patterns%2C%20professional%20clean%20design%20for%20password%20change%20interface&width=400&height=200&seq=passwordbg456&orientation=landscape')] opacity-10 bg-cover bg-center"></div>
              <div className="relative">
                <button
                  onClick={handleClosePasswordModal}
                  className="absolute top-0 right-0 w-8 h-8 flex items-center justify-center text-white/80 hover:text-white hover:bg-white/20 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
                <div className="pr-10">
                  <h2 className="text-2xl font-bold mb-2">修改密码</h2>
                  <p className="text-white/90 text-sm">
                    为了您的账户安全，请设置一个强密码
                  </p>
                </div>
              </div>
            </div>

            {/* Form Content */}
            <div className="flex-1 overflow-y-auto">
              <div className="p-6">
                <form onSubmit={handlePasswordSubmit} className="space-y-5">
                  {/* Current Password */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      当前密码
                    </label>
                    <div className="relative">
                      <i className="ri-lock-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                      <input
                        type={showCurrentPassword ? 'text' : 'password'}
                        value={passwordForm.currentPassword}
                        onChange={(e) => handlePasswordFormChange('currentPassword', e.target.value)}
                        placeholder="请输入当前密码"
                        className={`w-full pl-10 pr-12 py-3 border rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm transition-colors ${passwordErrors.currentPassword ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
                          }`}
                        required
                      />
                      <button
                        type="button"
                        onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer"
                      >
                        <i className={showCurrentPassword ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
                      </button>
                    </div>
                    {passwordErrors.currentPassword && (
                      <p className="mt-1 text-xs text-red-600 flex items-center">
                        <i className="ri-error-warning-line mr-1"></i>
                        {passwordErrors.currentPassword}
                      </p>
                    )}
                  </div>

                  {/* New Password */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      新密码
                    </label>
                    <div className="relative">
                      <i className="ri-lock-password-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                      <input
                        type={showNewPassword ? 'text' : 'password'}
                        value={passwordForm.newPassword}
                        onChange={(e) => handlePasswordFormChange('newPassword', e.target.value)}
                        placeholder="请输入新密码（6-20位）"
                        className={`w-full pl-10 pr-12 py-3 border rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm transition-colors ${passwordErrors.newPassword ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
                          }`}
                        required
                        minLength={6}
                        maxLength={20}
                      />
                      <button
                        type="button"
                        onClick={() => setShowNewPassword(!showNewPassword)}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer"
                      >
                        <i className={showNewPassword ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
                      </button>
                    </div>
                    {passwordErrors.newPassword && (
                      <p className="mt-1 text-xs text-red-600 flex items-center">
                        <i className="ri-error-warning-line mr-1"></i>
                        {passwordErrors.newPassword}
                      </p>
                    )}

                    {/* Password Strength Indicator */}
                    {passwordForm.newPassword && (
                      <div className="mt-2">
                        <div className="flex items-center space-x-2">
                          <div className="flex-1 bg-gray-200 rounded-full h-2">
                            <div
                              className={`h-2 rounded-full transition-all duration-300 ${passwordForm.newPassword.length >= 12 ? 'w-full bg-green-500' :
                                  passwordForm.newPassword.length >= 8 ? 'w-2/3 bg-yellow-500' :
                                    passwordForm.newPassword.length >= 6 ? 'w-1/3 bg-red-500' :
                                      'w-0'
                                }`}
                            ></div>
                          </div>
                          <span className={`text-xs ${passwordForm.newPassword.length >= 12 ? 'text-green-600' :
                              passwordForm.newPassword.length >= 8 ? 'text-yellow-600' :
                                passwordForm.newPassword.length >= 6 ? 'text-red-600' :
                                  'text-gray-500'
                            }`}>
                            {passwordForm.newPassword.length >= 12 ? '强' :
                              passwordForm.newPassword.length >= 8 ? '中' :
                                passwordForm.newPassword.length >= 6 ? '弱' : ''}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Confirm Password */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      确认新密码
                    </label>
                    <div className="relative">
                      <i className="ri-lock-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                      <input
                        type={showConfirmPassword ? 'text' : 'password'}
                        value={passwordForm.confirmPassword}
                        onChange={(e) => handlePasswordFormChange('confirmPassword', e.target.value)}
                        placeholder="请再次输入新密码"
                        className={`w-full pl-10 pr-12 py-3 border rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm transition-colors ${passwordErrors.confirmPassword ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
                          }`}
                        required
                      />
                      <button
                        type="button"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer"
                      >
                        <i className={showConfirmPassword ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
                      </button>
                    </div>
                    {passwordErrors.confirmPassword && (
                      <p className="mt-1 text-xs text-red-600 flex items-center">
                        <i className="ri-error-warning-line mr-1"></i>
                        {passwordErrors.confirmPassword}
                      </p>
                    )}

                    {/* Match Indicator */}
                    {passwordForm.confirmPassword && passwordForm.newPassword && (
                      <div className="mt-1 flex items-center">
                        {passwordForm.newPassword === passwordForm.confirmPassword ? (
                          <p className="text-xs text-green-600 flex items-center">
                            <i className="ri-check-line mr-1"></i>
                            密码匹配
                          </p>
                        ) : (
                          <p className="text-xs text-red-600 flex items-center">
                            <i className="ri-close-line mr-1"></i>
                            密码不匹配
                          </p>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Security Tips */}
                  <div className="bg-blue-50 rounded-lg p-4 border border-blue-100">
                    <div className="flex items-start space-x-2">
                      <i className="ri-shield-check-line text-blue-500 text-sm mt-0.5"></i>
                      <div className="text-xs text-blue-700">
                        <p className="font-medium mb-1">密码安全建议</p>
                        <ul className="space-y-1">
                          <li>• 使用6位以上字符</li>
                          <li>• 包含字母、数字和特殊字符</li>
                          <li>• 避免使用生日、姓名等个人信息</li>
                          <li>• 定期更换密码保障账户安全</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <Button
                    type="submit"
                    size="lg"
                    className="w-full mt-6 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-semibold py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200"
                    disabled={isChangingPassword}
                  >
                    {isChangingPassword ? (
                      <div className="flex items-center justify-center">
                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                        修改中...
                      </div>
                    ) : (
                      <>
                        <i className="ri-shield-check-line mr-2"></i>
                        确认修改密码
                      </>
                    )}
                  </Button>
                </form>

                {/* Additional Info */}
                <div className="mt-6 p-4 bg-gray-50 rounded-xl">
                  <div className="flex items-center space-x-2 text-sm text-gray-600">
                    <i className="ri-information-line text-blue-500"></i>
                    <span>密码修改后，您需要重新登录所有设备</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
